module.exports = __webpack_public_path__ + "img/co5.c1895f5e.png";